import { useStore } from '@exodus/jotai';
import { useRef } from 'react';
export function useHydrateAtoms(values) {
    const store = useStore();
    const mounted = useRef(false);
    if (mounted.current)
        return;
    mounted.current = true;
    for (const [atom, ...args] of values) {
        store.set(atom, ...args);
    }
}
